import { Button } from "@material-ui/core";
import { useCurrentTenant } from "@qpr/client-library";
import clsx from "clsx";
import { t } from "i18next";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { useHistory } from "react-router-dom";

const useStyles = makeThemedStyles("Navigation.ActionButton", (theme) => ({
  button: {
    textAlign: "center",
    borderRadius: "30px",
    borderWidth: "0px",
    fontFamily: "Dubai",
    fontSize: "14px",
    fontWeight: 400,
    minWidth: "160px",
    lineHeight: "20px",
    letterSpacing: "0.04375px",
    padding: "0px 20px 0px 20px",
    cursor: "pointer",
    height: "36px",
    justifyContent: "space-evenly",
    textTransform: "none",
  },
  blueStoneBg: {
    backgroundColor: "#115E67",
    "&:hover": { backgroundColor: "#166f79" },
    color: "#fff",
    width: "170px",
    padding: "4px 16px",
    height: "40px",
  },
  greenBg: {
    background: "rgb(0, 169, 163)",
    "&:hover": {
      backgroundColor: "rgb(0, 169, 163, 0.7)",
    },
    color: "rgb(254, 254, 254)",
  },
  grayBg: {
    background: "rgb(248,248,248)",
    "&:hover": {
      backgroundColor: "rgb(238, 238, 243)",
    },
    color: "rgb(0, 0, 0)",
  },
}));

const ActionButton = ({
  text,
  type,
  link,
  color,
  startIcon,
  onClick,
}: {
  text: string;
  type?: string;
  link?: string;
  startIcon?: React.ReactNode;
  color?: "greenBg" | "blueStoneBg" | "grayBg";
  onClick?: () => void;
}) => {
  const classes = useStyles();
  const history = useHistory();
  const ctx = useAppContext();
  const tenant = useCurrentTenant();

  const clickHandler = React.useCallback(() => {
    if (onClick) {
      onClick();
    } else {
      history.push(`/${tenant.symbol}/${ctx.modelId}/${link}`);
    }
  }, [link, onClick]);
  return (
    <Button
      startIcon={startIcon}
      className={clsx(classes.button, classes[color || "grayBg"])}
      onClick={clickHandler}
    >
      {t(text)}
    </Button>
  );
};

export default ActionButton;
